import GroupPage from './GroupPage'
import Groups from './Groups'
import { GET_DISTRIBUTION_LISTS_QUERY } from './queries'

import { userEvent, within, screen, waitFor } from '@storybook/test'

export default {
  title: 'pages/Groups',
  component: Groups,
}

const Template = (args) => <GroupPage {...args} />

const DISTRIBUTION_LISTS = [
  {
    id: '1',
    updatedAt: '2026-02-16T21:28:29.963Z',
    createdBy: { id: '1', name: 'Bobby Dean', email: 'bdean@aol.com', __typename: "User" },
    name: 'Tech Team',
    description: 'Engineering, Design, Tech Support',
    usedInCount: 0,
    recipients: ['some@aol.com', 'email@aol.com', 'addresses@aol.com'],
    __typename: "DistributionList"
  },
  {
    id: '3',
    updatedAt: '2026-02-18T05:23:29.963Z',
    createdBy: { id: '2', name: 'Robert Frost', email: 'rfrost@aol.com', __typename: "User" },
    name: 'Marketing Team',
    usedInCount: 3,
    recipients: ['addresses@aol.com'],
    __typename: "DistributionList"
  },
]

const baseParameters = {
  reactRouter: {},
  orbit: {
    user: {
      id: 'me',
      name: 'Robert Frost',
      email: 'rfrost@aol.com',
    },
    records: [],
  },
  providers: {
    apollo: {
      mocks: [
        {
          request: {
            query: GET_DISTRIBUTION_LISTS_QUERY,
            variables: { userId: 'me' },
          },
          result: {
            data: {
              distributionLists: DISTRIBUTION_LISTS,
            },
          },
        },
      ],
    },
  },
}

const GROUP = { id: '1', name: 'Tech Team' }

async function openGroupHoverMenu(group: { id: string; name: string }) {
  await userEvent.hover(await screen.findByText(group.name))

  await userEvent.click(
    await screen.findByLabelText(new RegExp(`^Group\\s+${group.id}\\s+Menu$`, 'i')),
  )

  return await screen.findByRole('menu')
}

export const Default = {
  render: Template,
  args: {},
  parameters: baseParameters,
}

export const ViewGroup = {
  render: Template,
  args: {},
  parameters: baseParameters,
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement)
    await userEvent.click(await canvas.findByText(GROUP.name))
  },
}

export const AddNewGroup = {
  render: Template,
  args: {},
  parameters: baseParameters,
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement)
    const groupLists = await canvas.findByRole('group', { name: /group lists/i })
    await userEvent.click(
      within(groupLists).getByRole('button', { name: /add new group/i })
    )
  },
}

export const EditGroup = {
  render: Template,
  args: {},
  parameters: baseParameters,
  play: async () => {
    const menu = await openGroupHoverMenu(GROUP)
    await userEvent.click(within(menu).getByRole('menuitem', { name: /edit group/i }))
  },
}

export const DuplicateGroup = {
  render: Template,
  args: {},
  parameters: baseParameters,
  play: async () => {
    const menu = await openGroupHoverMenu(GROUP)
    await userEvent.click(within(menu).getByRole('menuitem', { name: /duplicate group/i }))
  },
}

export const DeleteGroupConfirm = {
  render: Template,
  args: {},
  parameters: baseParameters,
  play: async () => {
    const menu = await openGroupHoverMenu(GROUP)
    await userEvent.click(within(menu).getByRole('menuitem', { name: /delete group/i }))

    await waitFor(async () => {
      await screen.findByText(/delete group/i)
    })
  },
}
